import { formatCheckoutPrice } from "@/lib/checkout-price";
import type { AccountOrder } from "./account-api";

export function formatAccountDate(iso: string): string {
  if (!iso) return "";
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return iso.slice(0, 10);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso.slice(0, 10);
  }
}

export function formatAccountCivilDate(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return value;
  const [, year, month, day] = match;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function accountLocalCivilDate(
  now: Date = new Date(),
  timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
): string {
  const parts = new Intl.DateTimeFormat("en", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? "";
  return `${value("year")}-${value("month")}-${value("day")}`;
}

export function formatAmountInr(amount: number | null): string {
  if (!amount) return "";
  return `Rs. ${amount.toLocaleString("en-IN")}`;
}

export function formatAccountAmount(
  order: Pick<AccountOrder, "amount_inr" | "amount_minor" | "currency">
): string {
  if (order.amount_minor && order.currency) {
    return formatCheckoutPrice({
      priceInr: order.amount_inr ?? 0,
      checkoutAmountMinor: order.amount_minor,
      checkoutCurrency: order.currency,
    });
  }
  return formatAmountInr(order.amount_inr);
}
